<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex
          xs6
          sm6
          md9
        >
          <h4 style="color:#2E7D32;">
            {{ makeOrderData.order_id ? `UPDATE ORDER ${makeOrderData.theOrderID}` : 'REQUEST ORDER' }}
          </h4>
        </v-flex>
        <!-- <v-flex
          xs6
          sm6
          md3
          style="padding-top: 5px; "
        >
          <v-btn
            flat
            outline
            color="green"
            @click="showWarehouseSection()"
            style="height:auto; padding-left: 0px; padding-right: 0px"
          >Purchase Via &nbsp;<i
              :class="x === 1 ? 'fa fa-angle-down' : 'fa fa-angle-up'"
              style="font-size: 20px"
            ></i></v-btn>
        </v-flex> -->
      </v-layout>
    </v-container>

    <div
      v-if="false"
      class="col-dm-12 col-md-12"
      style="margin-top: 10px ; border-top-style: solid; border-width: 2px; border-color: #388E3C;"
    >
      <div
        style="display: none"
        id="ware"
      >
        <div class="col-sm-12 col-md-5 col-md-offset-1">
          <h4><b>USA</b></h4>
          <h6><b>Username: </b>{{ loggedInUserData.full_name }}</h6>
          <h6>{{ usaWarehouse.street }}</h6>
          <!-- <h6><b>Zip code: </b>{{ usaWarehouse.code }}</h6> -->
          <h6>{{ usaWarehouse.state_province }}</h6>
          <h6>{{ usaWarehouse.phone_number }}</h6>
        </div>
        <!-- <div class="col-sm-12 col-md-6">
          <h4><b>Turkey</b></h4>
          <h6><b>Username: </b>{{ loggedInUserData.full_name }}</h6>
          <h6><b>City: </b>{{ turkeyWarehouse.city }}</h6>
          <h6><b>Postal Code: </b>{{ turkeyWarehouse.code }}</h6>
          <h6><b>State/Province: </b>{{ turkeyWarehouse.state_province }}</h6>
          <h6><b>Street: </b>{{ turkeyWarehouse.street }}</h6>
          <h6><b>House No: </b>{{ turkeyWarehouse.house_number }}</h6>
        </div> -->
      </div>
    </div>
    <div
      class="col-md-12"
      style="border-bottom-style: solid; border-width: 2px; border-color: #388E3C"
    ></div>

    <form
      action=""
      @submit.prevent="submitForm()"
    >
      <v-alert
        type="success"
        :value="checkAlert"
      >
        Order Requested successfully
      </v-alert>
      <v-alert
        type="error"
        :value="checkURL"
      >
        URL format not acceptable
      </v-alert>
      <v-container grid-list-md>
        <div class="col-md-5">
          <v-text-field
            label="Product Name*"
            v-model="makeOrderData.product_name"
            :error-messages="errors.collect('product_name')"
            v-validate="'required'"
            data-vv-name="product_name"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Product url*"
            v-model="makeOrderData.product_url"
            :error-messages="errors.collect('product_url')"
            v-validate="'required'"
            data-vv-name="product_url"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Quantity*"
            v-model="makeOrderData.quantity"
            :error-messages="errors.collect('quantity')"
            v-validate="'required|numeric|min_value:1'"
            data-vv-name="quantity"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-select
            :items="warehouses"
            v-model="makeOrderData.warehouse_id_fk"
            :error-messages="errors.collect('warehouse_id_fk')"
            data-vv-name="warehouse_id_fk"
            label="Warehouse*"
            v-validate="'required'"
            single-line
          >
          </v-select>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Type"
            v-model="makeOrderData.type"
            data-vv-name="type"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Size"
            v-model="makeOrderData.size"
            data-vv-name="size"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Color"
            v-model="makeOrderData.color"
            data-vv-name="color"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Note"
            v-model="makeOrderData.note"
            data-vv-name="note"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Coupon"
            v-model="makeOrderData.coupon"
            data-vv-name="coupon"
          ></v-text-field>
          <span
            v-if="notCouponCode"
            style="color: red"
          >This field must contain a Coupon Code</span>
        </div>

        <!--<div class="col-md-6">-->
        <!--<h5 class="lead" style="padding-top: 2%">-->
        <!--<input type="checkbox" v-model="makeOrderData.c_o_d" name="c_o_d" style="width:20px;height:20px;padding:10px" > &nbsp; Cash on deliver-->
        <!--</h5> -->
        <!--</div> -->
      </v-container>
      <v-spacer></v-spacer>
      <div class="col-sm-10 col-md-5 col-md-offset-3">
        <v-btn
          type="submit"
          :loading="loading"
          style="width: 100%; height:auto; margin-bottom: 3%"
          color="success"
        >
          {{ makeOrderData.order_id ? 'Update' : 'Request' }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  // created() {
  //   let thePanel = document.querySelector('.panel-flat')
  //   thePanel.style.overflowX = 'hidden'
  // },

  mounted() {
    this.getLoggedInUser()
    this.getWarehouses()
    this.getWarehousesToSelect()
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }

    // if edit mode get order data
    if (
      window.location.search.replace('?order_id=', '') !== null ||
      window.location.search.replace('?order_id=', '') !== ''
    ) {
      this.theOrderId = Number(window.location.search.replace('?order_id=', ''))
      if (this.theOrderId && this.theOrderId > 0) {
        this.getOrder()
      }
    }
    // console.log(this.$route.query.order_id)
    // console.log(this.$route.query && this.$route.query.order_id ? 'true' : 'false')
    // if (this.$route)
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      makeNewOrderUrl: 'api/orders/customer-store',
      showWarehouseUrl: 'api/warehouses',
      loggedInUserData: {},
      theOrderId: null,
      checkAlert: false,
      checkURL: false,
      loading: false,
      notCouponCode: false,
      x: 1,
      usaWarehouse: [],
      turkeyWarehouse: [],
      warehouses: [],
      deliveryTypes: [
        { text: 'Home Delivery', value: 'home delivery' },
        { text: 'Office Delivery', value: 'office delivery' }
      ],
      makeOrderData: {
        warehouse_id_fk: 1,
        product_name: '',
        product_url: '',
        quantity: '',
        // delivery_type: "",
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: ''
        // c_o_d: "",
      }
    }
  },

  methods: {
    getOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/customer_order_detail/${this.theOrderId}`, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.makeOrderData = response.data.data[0]
        })
    },

    getWarehousesToSelect() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data
          result.forEach(r => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2
        $('#ware').show('slow')
      } else if (this.x === 2) {
        this.x = 1
        $('#ware').hide('slow')
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.showWarehouseUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.usaWarehouse = response.data.data[0]
          this.turkeyWarehouse = response.data.data[1]
        })
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.makeOrderData.coupon && this.makeOrderData.coupon !== '') {
            if (this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              this.notCouponCode = false
              this.makeNewOrder()
            } else {
              this.notCouponCode = true
            }
          } else {
            this.notCouponCode = false
            this.makeNewOrder()
          }
        }
      })
    },

    makeNewOrder() {
      this.loading = true
      let token = localStorage.getItem('access_token')

      // edit
      if (this.makeOrderData.order_id) {
        axios
          .put(`api/update-order-by-customer/${this.makeOrderData.order_id}`, this.makeOrderData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(() => {
            this.checkURL = false
            this.loading = false
            this.checkAlert = true
            setTimeout(() => {
              this.clearNewOrerData()
              this.$router.push('/my-order')
            }, 2000)
          })
          .catch(error => {
            this.loading = false
            this.checkAlert = false
            if (error.response.data.message.product_url) {
              this.checkURL = true
            } else {
              this.checkURL = false
              swal('Error', `${error.response.data.message}`, 'error')
            }
          })
      } else { // add
        axios
          .post(this.makeNewOrderUrl, this.makeOrderData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.checkURL = false
            this.loading = false
            this.checkAlert = true
            let a = this
            setTimeout(function () {
              a.clearNewOrerData()
            }, 2000)
          })
          .catch(error => {
            this.loading = false
            this.checkAlert = false
            if (error.response.data.message.product_url) {
              this.checkURL = true
            } else {
              this.checkURL = false
              swal('Error', `${error.response.data.message}`, 'error')
            }
          })
      }
    },

    clearNewOrerData() {
      this.makeOrderData.warehouse_id_fk = ''
      this.makeOrderData.product_name = ''
      this.makeOrderData.product_url = ''
      this.makeOrderData.quantity = ''
      // this.makeOrderData.delivery_type = "",
      this.makeOrderData.coupon = ''
      this.makeOrderData.size = ''
      this.makeOrderData.type = ''
      this.makeOrderData.color = ''
      this.makeOrderData.c_o_d = ''
      this.checkAlert = false
      this.checkURL = false
      this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/makeNewOrder.vue